// CTA LABELS
export const CART_CHECKOUT_LABEL = 'Checkout';
export const CART_INVALID_ADDRESS_LABEL = 'Remove Items To Continue';
export const CART_INVALID_FULFILLMENT_TIME_LABEL = 'Update Time To Continue';
export const CART_INVALID_ORDER_MINIMUM_LABEL = 'Add Items to Continue';
export const CART_PICKUP_ADDRESS_CHANGED_LABEL = 'Refresh Cart';

// CART CONFIRMATION MODAL TYPES
export const EMPTY_CART_CONFIRMATION_MODAL = 'emptyCartConfirmationModal';
export const LEAVE_GROUP_ORDER_MODAL = 'leaveGroupOrderModal';
export const GROUP_ORDER_JOIN_LEAVE_CONFIRMATION_MODAL =
  'groupOrderJoinLeaveConfirmationModal';
export const CANCEL_GROUP_ORDER_CONFIRMATION_MODAL =
  'cancelGroupOrderConfirmationModal';
export const GROUP_ORDER_CHECKOUT_CONFIRMATION_MODAL =
  'groupOrderCheckoutConfirmationModal';
